export default {
  LIST: 'VOD.LIST_ITEMS.LIST',
  LIST_PUBLIC: 'VOD.LIST_ITEMS.LIST_PUBLIC',
  LIST_NEXT_IN_CHANNEL: 'VOD.LIST_ITEMS.LIST_NEXT_IN_CHANNEL',
  ADD: 'VOD.LIST_ITEMS.ADD',
  GET: 'VOD.LIST_ITEMS.GET',
  GET_PUBLIC: 'VOD.LIST_ITEMS.GET_PUBLIC',
  UPDATE: 'VOD.LIST_ITEMS.UPDATE',
  REMOVE: 'VOD.LIST_ITEMS.REMOVE',
  REMOVE_BY_BASE_ITEM_ID: 'VOD.LIST_ITEMS.REMOVE_BY_BASE_ITEM_ID',
  MOVE: 'VOD.LIST_ITEMS.MOVE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/list-items.js